import { useState } from 'react';
import {Button, Form} from 'react-bootstrap';
import { ArrowLeft } from 'react-bootstrap-icons';
import '../styles/login.css'
import './LoginForm.css'


function LoginForm({
    username,
    password,
    setUsername,
    setPassword,
    otpEmail,
    setOtpEmail,
    changeAuthMode,
    setForgotPassword,
    handleLogin,
    handlePasswordlessLogin,
    setTroubleLoggingIn,
    getUsername,
    passwordlessLogin,
    changeLoginMode,
    otp,
    setOtp,
    validateOtp,
    setValidateOtp,
    sendOtp
}) {
    const [otpMessage, setOtpMessage] = useState(true);
    const [emailMessage, setEmailMessage] = useState(true);

    const handleOtpChange = (event) => {
        const value = event.target.value;

        const regex = /^\d{4}$/
        if (/^.*$/.test(value)) {
          if (value.length === 4 || regex.test(value)) {
            setOtpMessage(value.length > 4? '' : '');
          } else {
            setOtpMessage(false);
          }
        } else {
            setOtpMessage(true);
        }
    }

      const handleEmailChange = (event) => {
        const value = event.target.value;

        const emailRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        if (/^.*$/.test(value) && emailRegex.test(value)) {
            setEmailMessage(false);
        } else {
            setEmailMessage(true);
        }
    }

    if (validateOtp) {
        return (
            <>
                <div className='login-section'>
                    <Form>
                    <Form.Group className='mb-3'>
                        <Form.Label>Code</Form.Label>
                        <Form.Control required value={otp} onChange={(e) => { handleOtpChange(e); setOtp(e.target.value)} } placeholder='Enter 4 digit code' />
                        <Form.Text className='text-muted'>
                        </Form.Text>
                        <Button className='anchor-button go-back' onClick={() => {setValidateOtp(false)}}><ArrowLeft/> Go back</Button>

                    </Form.Group>


                    {/* <div>
                        <Button className='anchor-button' onClick={setTroubleLoggingIn}>Can't Login? </Button>
                        <Button className='anchor-button' onClick={changeAuthMode}>Sign up</Button>
                    </div> */}
                    {/* <Button variant='secondary' onClick={changeLoginMode}>Login with username and password </Button> */}
                    </Form>

                    <Button disabled={otpMessage} onClick={handlePasswordlessLogin} variant='primary'>Login</Button>
                </div>
            </>       
        );
    }

    // if (passwordlessLogin) {
    //     return (
    //         <>
    //             <div className='login-section'>
    //                 <Form>
    //                 <Form.Group className='mb-3'>
    //                     <Form.Label>Login with one-time passcode </Form.Label>
    //                     {/* <br></br> */}
    //                     {/* <Button className='anchor-button' onClick={changeLoginMode}>Login with username and password</Button> */}
    //                     <Form.Control value={username} onChange={(e) => setUsername(e.target.value)} type='email' placeholder='Enter email' />
    //                     <Form.Text className='text-muted'>
    //                     </Form.Text>
    //                 </Form.Group>
    //                 <div>
    //                     <Button className='anchor-button' onClick={setTroubleLoggingIn}>Can't Login? </Button>
    //                     <Button className='anchor-button' onClick={changeAuthMode}>Sign up</Button>
    //                 </div>
    
    //                 </Form>
    //                 <Button onClick={()=> {setValidateOtp(true); sendOtp()}} variant='primary'>Submit</Button>
    //             </div>
    //         </>       
    //     );
    // }
    
    return (
        <>
            <div className='login-section'>
                <Form>
                    <Form.Group className='mb-3'>
                        <Form.Label>Login with one-time passcode </Form.Label>
                        {/* <br></br> */}
                        {/* <Button className='anchor-button' onClick={changeLoginMode}>Login with username and password</Button> */}
                        <Form.Control required value={otpEmail} onChange={(e) => {handleEmailChange(e); setOtpEmail(e.target.value) }} type='email' placeholder='Enter email' />
                        <Form.Text className='text-muted'>
                        </Form.Text>
                    </Form.Group>
                    {/* <div>
                        <Button className='anchor-button' onClick={setTroubleLoggingIn}>Can't Login? </Button>
                        <Button className='anchor-button' onClick={changeAuthMode}>Sign up</Button>
                    </div> */}
                </Form>
                <Button disabled={emailMessage} onClick={()=> {sendOtp()}} variant='primary'>Submit</Button>
                
                {/* <br></br> */}
                <div class="separator">OR</div>

                <Form>
                <Form.Group className='mb-3'>
                    <Form.Label>Username</Form.Label>
                    <Form.Control required value={username} onChange={(e) => setUsername(e.target.value)} type='username' placeholder='Enter username' />
                    <Form.Text className='text-muted'>
                    </Form.Text>
                </Form.Group>

                <Form.Group className='mb-3'>
                    <Form.Label>Password</Form.Label>
                    <Form.Control required value={password} onChange={(e) => setPassword(e.target.value)} type='password' placeholder='Password' />
                </Form.Group>
                {/* <Button variant='secondary' onClick={changeLoginMode}>Login with one-time code </Button> */}
                <div className='login-links-row'>
                    <Button className='anchor-button' onClick={setTroubleLoggingIn}>Can't Login? </Button>
                    <Button className='anchor-button' onClick={changeAuthMode}>Sign up</Button>
                </div>

                </Form>
                <Button disabled={username.length == 0 || password.length == 0} onClick={handleLogin} variant='primary'>Login</Button>
            </div>
        </>       
    );

}

export default LoginForm;